




















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import * as goodsApi from '@/api/goods'
import ENV_CONFIG from '../../config'
import * as weixin from '@ivy/fts/weixin'
import { addStatisticsA } from './activityStatistics'
import showDiv from '@ivy/fts/showDiv'
import levelShow from '@/components/levelShow.vue'
import LevelAttrShow from '@/components/levelAttrShow.vue'
import GroupBox from '@/components/groupBox.vue'
import HeadPicture from './comps/HeadPictur.vue'
import DiscountSale from './comps/DiscountSale.vue'
import DiscountSaleVip from './comps/DiscountSaleVip.vue'
import LookSale from './comps/LookSale.vue'
import GetCoupon from './comps/GetCoupon.vue'
import FootView from './comps/FootView.vue'
import GoodsContent from './comps/GoodsContent.vue'
import GoodsInfo from './comps/GoodsInfo.vue'
import GoodsGift from './comps/GoodsGift.vue'
import TitleBar from './comps/TitleBar.vue'
import GoodsSalesList from '../comps/goodsSalesList.vue'
import { addStatistics } from './require'
import * as helper from '@/helper'
import { uploadEvent } from '@/api/goods/statistics'
import DiscountSaleDist from './comps/DiscountSaleDist.vue'
import ShareModel from './comps/ShareModel.vue'
import FollowModel from './comps/FollowModel.vue'
import GoldVirtually from './comps/GoldVirtually.vue'

@Component({
  name: 'goods-index',
  components: {
    HeadPicture,
    DiscountSale,
    DiscountSaleVip,
    LookSale,
    GetCoupon,
    GroupBox,
    FootView,
    GoodsInfo,
    GoodsContent,
    GoodsGift,
    TitleBar,
    GoodsSalesList,
    DiscountSaleDist,
    ShareModel,
    FollowModel,
    GoldVirtually,
  },
})
export default class GoodsView extends Vue {
  show: boolean = false // 是否显示页面
  isloading: boolean = true
  isLoaded: boolean = false
  ios10Shadow: boolean = false
  queryParams: any = {} // url的query信息
  spu: any = {} // spu数据
  skus: any[] = [] // 多sku数据
  attrs: any = {} // 多sku的规格选项
  attrsMap: any = {} // attrs => attrsMap
  curLevel: any = {} // 选中的skus
  invitationData: any = {} // 转介绍的数据
  skuActivity: any[] = [] // 活动的sku
  coupons: any[] = [] // 优惠劵
  discountData: any = {} // 预售、拼团、折扣信息
  courseData: any = null // 虚拟商品 -> 课程
  giftList: any[] = [] // 赠品
  addressChecked: any = {} // 地址
  distribution: any = {} // 分享信息
  navbarHeight: number = 0
  collocationList: any = [] // 搭配售列表
  playTime: number = 0 //播放时长用于埋点
  timerGenerator: any // 用于埋点
  errorText: string = ''
  skuStatus: string = ''
  openTime: number = 0
  durationTime: number = 0
  isExposured: Boolean = false
  isGroupGoods: Boolean = false
  isVip: Boolean = false //登陆账户是否是会员
  showShare: boolean = false // 分销的分享控制
  isDistributor: boolean = false // 是否是分销员
  share_img_url: string = null
  showFollow: boolean = false // 是否弹出关注框

  get isApp() {
    return env.type === 'ivydad' || env.type === 'web'
  }
  get point() {
    // 埋点数据
    return this.curLevel.id
      ? this.$route.query.spuId + '_' + this.curLevel.id
      : this.$route.query.spuId
  }
  get ticketOnly() {
    let ticketOnly = this.queryParams.ticketOnly
    return ticketOnly ? !+ticketOnly : false
  }

  get getGoodsContentClass() {
    let _c =
      this.discountData.activity_type &&
      this.discountData.activity_type !== 'scholarship_distribution'
        ? 'discount-sale-mixmargtop'
        : this.discountMargtop
    return _c
  }
  get isDistribution() {
    return this.curLevel.activityType === 'distribution'
  }
  get showPresell() {
    let hasId = this.discountData.id
    if (!this.showPresellCom) {
      return false
    }
    let start_time =
      hasId && this.discountData.presell_start_time.replace(/-/g, '/')
    let end_time =
      hasId && this.discountData.presell_end_time.replace(/-/g, '/')
    let isPreselling =
      new Date(start_time).getTime() <= new Date().getTime() &&
      new Date().getTime() < new Date(end_time).getTime()
    return isPreselling
  }
  get showPresellCom() {
    let isPresell = this.discountData.activity_type === 'presell'
    let hasId = this.discountData.id
    return isPresell && hasId
  }
  get showLookSale() {
    return (
      this.discountData.activity_type === 'group' &&
      this.discountData.front_app_id
    )
  }
  get isInvitation() {
    let { invitation } = this.$route.query
    return !!invitation
  }
  get showGroupBox() {
    return (
      this.discountData.activity_type === 'group' &&
      this.discountData.id &&
      this.spu.scope
    )
  }

  get specialConfig() {
    return {}
  }

  get discountMargtop() {
    //金币商城不需要展示价格区
    if (this.$route.query.invitation) return ''
    if (this.isDistribution) {
      return ''
    }
    if (this.discountData.activity_type) {
      return 'discount-sale-mixmargtop'
    }

    if (this.isVip || !this.curLevel.vipPrice) {
      return 'discount-sale-mixmargtop'
    } else {
      return 'discount-sale-maxmargtop'
    }
  }
  get discountPadding() {
    let havevipPrice
    if (
      this.curLevel.activityType === 'vipPrice' &&
      this.curLevel.vipPrice !== null
    ) {
      havevipPrice = true
    } else {
      havevipPrice = false
    }
    if (this.isDistributor) {
      return false
    }
    if (
      havevipPrice ||
      (this.curLevel.activities &&
        this.curLevel.activities.gift &&
        Object.keys(this.curLevel.activities.gift).length !== 0) ||
      (this.discountData.activity_type &&
        this.discountData.goods_id === this.curLevel.id) ||
      this.discountData.product_id === this.curLevel.id
    ) {
      return true
    } else {
      return false
    }
  }

  get computedCourseData() {
    return this.curLevel.id ? this.curLevel.virtual : this.courseData
  }

  get name() {
    return this.spu.scope === 'goods' ? Object.keys(this.attrs)[0] : '商品'
  }

  get showGifts() {
    //是否含有赠品
    if (!this.skus.length || !this.curLevel || !this.curLevel.id) {
      let gift_list = []
      for (let sku of this.skus) {
        let gifts =
          (sku.activities &&
            sku.activities.gift &&
            sku.activities.gift.giftList &&
            sku.activities.gift.giftList.filter(e => !e.soldOut)) ||
          (sku.gifts && sku.gifts.filter(e => e.is_show_gift))
        gift_list = gift_list.concat(gifts || [])
      }
      this.giftList = [...new Set(gift_list)]
      if (this.giftList.length === 0) return false
      return true
    }
    this.giftList =
      (this.curLevel.activities &&
        this.curLevel.activities.gift &&
        this.giftEnable(this.curLevel.activities.gift) &&
        this.curLevel.activities.gift.giftList.filter(e => !e.soldOut)) ||
      (this.curLevel.gifts &&
        this.curLevel.gifts.giftList.filter(e => e.isShoWGift)) ||
      []
    return this.giftList && this.giftList.length
  }

  get saleCount() {
    const countMap = {
      '111423532500': 6996,
      '111423532501': 1230,
      '111423532505': 2,
    }
    const totalCount = 8228

    if (Object.keys(this.curLevel).length) {
      return +this.spu.id === 10544
        ? countMap[this.curLevel.barcode + '']
        : this.curLevel.saleCount
    } else {
      return +this.spu.id === 10544 ? totalCount : this.spu.saleCount
    }
  }
  get isSaleOut() {
    // 如果选中了sku
    if (this.curLevel && this.curLevel.id) {
      return this.curLevel.virtualInventoryQty < 1
    }
    // 所有的sku
    return this.skus.reduce((sum, cur) => {
      return !!(cur.virtualInventoryQty <= 0 && sum)
    }, true)
  }
  get goodsStatus() {
    let sku = this.curLevel || {}
    if (Object.keys(sku).length > 0) {
      // 选中的sku已售罄
      if (sku.virtualInventoryQty < 1) {
        return sku.isVirtual ? '名额已满' : '已售罄'
      }
      // 即将开售
      if (sku.planPublishTime) {
        let t1 = new Date(sku.planPublishTime.replace(/-/gi, '/')).getTime()
        let t2 = new Date().getTime()
        let day7 = t1 - t2 - 7 * 24 * 60 * 60 * 1000
        if (day7 < 0) {
          return '即将开售-有倒计时'
        } else {
          return '即将开售'
        }
      }
      // 即将停售
      if (sku.planUnpublishTime) {
        let t1 = new Date(sku.planUnpublishTime.replace(/-/gi, '/')).getTime()
        let t2 = new Date().getTime()
        if (t1 < t2) {
          return {
            text: '商品已下架',
            clz: 'volcano',
            needTimer: false,
          }
        }
        let day7 = t1 - t2 - 7 * 24 * 60 * 60 * 1000
        // 7天内
        if (day7 < 0) {
          return '即将停售'
        }
      }
      // 选中的sku已下架
      if (sku.state === 'unpublished') {
        return '已下架'
      }
      if (this.skuStatus) {
        return '缺货'
      }

      return '正常售卖'
    } else {
      if (this.isSaleOut) {
        return this.spu.type === 'virtual' ? '名额已满' : '已售罄'
      }
      if (this.spu.state === 'unpublished') {
        return '已下架'
      }
      return '正常售卖'
    }
  }

  @Watch('curLevel.id', { deep: true })
  skuChanged(newV) {
    if (!this.isApp) {
      this.setShare()
    }
  }
  async created() {
    this.getUserIsVip()
  }
  async mounted() {
    let {
      isAppTab,
      scholarship_distributor_id,
      selectSkuId,
    } = this.$route.query
    this.openTime = new Date().getTime()
    this.initDisplayEvent()
    await this.initMounted('init')
    await uploadEvent.init()
    uploadEvent[+isAppTab ? 'sendRecord' : 'sendPV'](
      'Exposure_Page',
      '',
      { PageName: '商品详情页', FromPage: 1 },
      [
        ['p1', 'PageName'],
        ['p2', 'FromPage'],
      ]
    ).then(() => {
      this.isExposured = true
      uploadEvent.sendRecord(
        'Exposure_GoodsDetail',
        '',
        {
          FromPage: 1,
          GoodsName: this.spu.title,
          SpuID: this.spu.id.toString(),
          SkuType: this.spu.state,
          GoldmallnName: this.$route.query.invitation ? 'Gold' : '',
        },
        [
          ['p1', 'SpuID'],
          ['p2', 'SkuType'],
          ['p3', 'FromPage'],
          ['p4', 'GoldmallnName'],
        ]
      )
    })
    scholarship_distributor_id &&
      this.isDistribution &&
      uploadEvent.sendRecord(
        'Poster Scanning Succeeded_Scholarship',
        '',
        {
          Time: new Date().format('YYYY-MM-DD hh:mm:ss'),
          SkuID: selectSkuId || '',
          ScholarshipDistributorId: scholarship_distributor_id,
        },
        [
          ['p1', 'Time'],
          ['p2', 'SkuID'],
          ['p3', 'ScholarshipDistributorId'],
        ]
      )
  }
  async getUserIsVip() {
    await env.init()
    if (!(await env.getIsLogin())) {
      return
    }
    let loginfo = await env.getInfo()
    if (this.isApp) {
      if (loginfo.userInfo && loginfo.userInfo.isVip == '1') this.isVip = true
    } else {
      if (loginfo.logined && loginfo.logined.vip) this.isVip = true
    }
  }
  async getGoodsPrice(spuId) {
    let { data: goodsPriceData } = await goodsApi.getGoodsPrice(spuId)
    this.invitationData = goodsPriceData
  }
  // 初始化数据
  async initMounted(level) {
    let isInit = level === 'init'
    await env.init()
    let { spuId, invitation } = this.$route.query
    this.queryParams = this.$route.query || {}

    // 埋点
    isInit && this.addInvitationPoint()
    try {
      // 核心，获取 spu 信息
      await this.getGoodsData()
    } catch (err) {
      this.errorText = err.message || '加载失败...'
      this.isloading = false
      this.isLoaded = true
      this.show = false
      // await env.init()
      this.navbarHeight = (await env.getNavbarHeight()) || 25
      return Promise.reject({ ignore: true })
    }
    this.isLoaded = true
    this.show = true
    // await env.init()
    if (invitation) {
      this.getGoodsPrice(spuId)
    }
    this.navbarHeight = (await env.getNavbarHeight()) || 25
    this.getAllGoodsData(level)

    //埋点 商品页曝光
    isInit &&
      addStatistics({
        event: 'ExposureTimes_GoodDetails_H5',
        p1: this.$route.query.nativeFrom, // 页面来源
        p2: this.point,
        p3: this.goodsStatus,
      })
    // 埋点 商品详情页访问时长
    isInit && this.startStatistics()
  }
  initDisplayEvent() {
    if (env.type === 'ivydad') {
      document.addEventListener('visibilitychange', this.visibilityChange)
    }
  }
  async visibilityChange() {
    var isHidden = document.hidden
    let isAppTab = this.$route.query.isAppTab || ''
    console.log('isHidden', isHidden)
    if (isHidden) {
      let now = new Date().getTime()
      let timeDuration = now - this.openTime
      this.openTime = now
      this.durationTime = timeDuration + this.durationTime
      console.log('隐藏， 持续时长： ', this.durationTime)
    } else {
      this.openTime = new Date().getTime()
      //获取当前用户信息
      await this.getUserIsVip()
      if (this.isExposured) {
        uploadEvent[+isAppTab ? 'sendRecord' : 'sendPV'](
          'Exposure_Page',
          '',
          { PageName: '商品详情页', FromPage: 1 },
          [
            ['p1', 'PageName'],
            ['p2', 'FromPage'],
          ]
        )
      }
    }
  }
  async beforeDestroy() {
    // 埋点，持续时长
    let now = new Date().getTime()
    let timeDuration = now - this.openTime
    this.durationTime = timeDuration + this.durationTime
  }
  async destroyed() {
    if (env.type === 'ivydad') {
      document.removeEventListener('visibilitychange', this.visibilityChange)
    }
    clearInterval(this.timerGenerator)
  }
  // 刷新接口，获取最新的数据信息
  updatePage() {
    this.initMounted('update')
  }
  //获取搭配售列表
  async getCollectionList() {
    if (env.type === 'ivydad') {
      // 判断App版本，若小于3.7.0则不显示搭配售
      let info = (await env.getInfo()) || {}
      let publicParams = info.publicParams || {}
      let version = publicParams.version
      if (!version) return
      let isAppLt370 = helper.compareVersion(version, '3.7.0', '<')
      if (isAppLt370) {
        return
      }
    }
    if (!this.isGroupGoods) {
      let { data } = await goodsApi.getCollectionList({
        skuId: this.skus.map(i => i.id),
      })

      this.collocationList = data.sort((a, b) => {
        return b.id - a.id
      })
    }
  }

  addInvitationPoint() {
    // 转介绍扫码埋点
    let { _sessionStorageInviteActivityId, source } = this.queryParams
    if (_sessionStorageInviteActivityId) {
      try {
        let sourceEnv = source === 'wx' ? 'web端' : 'Appd端'
        window._czc.push([
          '_trackEvent',
          `转介绍活动${sourceEnv}`,
          '扫码',
          'Display_Success_Poster_zjs',
        ])
      } catch (err) {
        console.log(err)
      }
    }
  }
  // 获取商品数据
  async getGoodsData() {
    let {
      selectSkuId,
      scholarship_distribution_id,
      scholarship_distributor_id,
      invitation,
    } = this.$route.query
    let params
    if (+selectSkuId) {
      params = {
        spuId: this.queryParams.spuId,
        show_unpublish_sku: 1,
        isAllSku: false,
        skuId: +selectSkuId,
        is_gold: invitation === 'gold',
      }
    } else {
      params = {
        spuId: this.queryParams.spuId,
        show_unpublish_sku: 1,
        isAllSku: false,
        is_gold: invitation === 'gold',
      }
    }

    if (scholarship_distribution_id && scholarship_distributor_id) {
      params = {
        ...params,
        scholarship_distribution_id,
        scholarship_distributor_id,
      }
    }

    const { data: spuData } = await this.$axios.get(
      '/api/goods/shop/search/goods/getSpu',
      {
        params,
      }
    )
    let spu: any = spuData.spuInfo
    if (spu.replaceSpuId && spu.id && spu.replaceSpuId !== spu.id) {
      let origin =
        ENV_CONFIG.env === 'production'
          ? 'https://m.ivydad.com'
          : 'http://m.ivydad.com.cn'
      window.location.href = `${origin}/goods/goodsView?spuId=${spu.replaceSpuId}&type=${spu.type}`
      return
    }
    // 如果data的 scope 是 group_goods就不请求
    // console.log('pppppppppppp',spuData.spu.scope)
    if (spuData.spuInfo.scope && spuData.spuInfo.scope === 'group_goods') {
      this.isGroupGoods = true
    }
    this.spu = spuData.spuInfo
    let curLevel = this.curLevel || {}
    let hasSkuId = curLevel.id
    this.curLevel = {}
    await this.$nextTick()
    // 刷数据的时候如果curLevel存在，优先找curLevel.id
    if (hasSkuId) {
      curLevel = this.skus.find(item => item.id === +hasSkuId) || {}
    }
    // console.log('-----------------------------------------', curLevel)
    this.curLevel = spuData.skuInfos[0]
    !this.isApp && this.setShare()
    this.$title(this.spu.title)

    this.getSpuVirtual()
    if (scholarship_distribution_id && scholarship_distributor_id) {
      this.addDistPoint(
        'visit',
        scholarship_distribution_id,
        scholarship_distributor_id + ''
      )
    }
  }
  async getAllGoodsData(level) {
    let {
      selectSkuId,
      scholarship_distribution_id,
      scholarship_distributor_id,
      invitation,
    } = this.$route.query

    let params

    if (+selectSkuId) {
      params = {
        spuId: this.queryParams.spuId,
        show_unpublish_sku: 1,
        isAllSku: true,
        skuId: +selectSkuId,
        is_gold: invitation === 'gold',
      }
    } else {
      params = {
        spuId: this.queryParams.spuId,
        show_unpublish_sku: 1,
        isAllSku: true,
        is_gold: invitation === 'gold',
      }
    }

    if (scholarship_distribution_id && scholarship_distributor_id) {
      params = {
        ...params,
        scholarship_distribution_id,
        scholarship_distributor_id,
      }
    }
    const { data: spuData } = await this.$axios.get(
      '/api/goods/shop/search/goods/getSpu',
      {
        params,
      }
    )
    this.$nextTick()
    this.skus = spuData.skuInfos
    this.attrs = spuData.attrs || {}
    // 加载搭配售列表，无需 await
    if (!this.isInvitation) {
      this.getCollectionList()
    }
    // 获取优惠券信息
    this.getCoupon(level)
    // 获取分销信息
  }

  async getSpuVirtual() {
    let { data: courseData } = await goodsApi.getSpuVirtual({
      spuId: this.queryParams.spuId,
    })
    this.courseData = courseData && courseData.length ? courseData[0] : {}
  }

  async setShare() {
    let link = `${window.location.origin}${window.location.pathname}?spuId=${this.queryParams.spuId}&type=${this.spu.scope}`
    if (this.queryParams.invitation) link = window.location.href
    if (this.curLevel.isDistributionGoods) {
      await env.init()
      let loginfo = (await env.getInfo()) || {}
      let memId = loginfo.logined.user.id
      link += `&scholarship_distribution_id=${this.curLevel.distributionActivityId}&scholarship_distributor_id=${memId}`
    } else {
      link = window.location.href
    }
    let options = {
      title: this.spu.title,
      desc: this.spu.remark,
      imgUrl: this.spu.cover,
      link: encodeURI(link),
    }
    await weixin.weixinShare(options)
  }
  async startStatistics() {
    try {
      const remain = +new Date()
      this.timerGenerator = setInterval(async () => {
        await addStatistics({
          event: 'Display_Duration_GoodsDetails_H5',
          p1: this.$route.query.nativeFrom, // 访问来源
          p2: this.point,
          p3: remain,
          p4: this.goodsStatus,
        })
      }, 5000)
    } catch (err) {}
  }
  // 获取优惠/折扣sku信息
  async getCoupon(level) {
    let { ignoreDiscount, spuId, invitation } = this.$route.query
    let params = {
      spuId: spuId,
      skuIds: this.skus.map(i => i.id),
      type: this.spu.scope,
      ignoreDiscount: +!!ignoreDiscount,
      scholarship_distribution_id:
        this.$route.query.scholarship_distribution_id || '',
      scholarship_distributor_id:
        this.$route.query.scholarship_distributor_id || '',
    }

    if (invitation === 'gold') {
      params['is_gold'] = 1
    }
    let { data } = await goodsApi.discountActivity(params)

    this.skuActivity = data.skuActivity || {}
    this.coupons = data.coupons
    level === 'init' && this.addActivityStatistics(data.skuActivity)
    this.setActivity()
  }

  async addActivityStatistics(skuActivity) {
    if (!skuActivity) return
    for (let skuId in skuActivity) {
      if (!skuActivity[skuId]) continue
      await addStatisticsA('goods_visit', skuActivity[skuId])
    }
  }

  setActivity() {
    let skuId = this.curLevel ? this.curLevel.id : ''
    let activityKeys = Object.keys(this.skuActivity)
    // 没有折扣信息直接返回
    if (activityKeys.length === 0) {
      this.setOtherInfo({})
      return
    }
    // 有skuId时，表示选择了规格,或者有默认规格，或者activityKeys === 1
    if (skuId) {
      this.discountData = this.skuActivity[skuId] || {}
      this.setOtherInfo(this.discountData)
    } else {
      // 没有时，读取skuActivity里面的最低价
      let minPriceActivity = null
      let min = Infinity
      activityKeys.forEach(key => {
        let sku = this.skus.find(e => +e.id === +key)
        let value = this.skuActivity[key]
        if (value.activity_type === 'limit_buy') {
          let activitySalePrice = parseFloat(value.sale_price)
          if (activitySalePrice && activitySalePrice < min) {
            min = activitySalePrice
            minPriceActivity = {
              ...value,
              basePrice: sku.sale_price,
            }
          }
        }
      })
      if (minPriceActivity) {
        this.discountData = minPriceActivity
      }
    }
  }

  setOtherInfo(info = {}) {
    let { planPublishTime, planUnpublishTime } = this.curLevel
    let plan_publish_time = planPublishTime
    let plan_unpublish_time = planUnpublishTime
    // 即将开售
    if (plan_publish_time && !plan_unpublish_time) {
      // 当前时间和开售时间对比7天
      let day7 =
        new Date(plan_publish_time.replace(/-/gi, '/')).getTime() -
        new Date().getTime() -
        7 * 24 * 60 * 60 * 1000

      // 7天内
      if (day7 < 0) {
        this.discountData = {
          ...info,
          activity_type: 'will_sale',
        }
      } else {
        this.discountData = info
      }
    }
    // 即将停售
    if (!plan_publish_time && plan_unpublish_time) {
      // 当前时间和开售时间对比7天
      let t1 = new Date(plan_unpublish_time.replace(/-/gi, '/')).getTime()
      let t2 = new Date().getTime()

      // 7天内
      if (t1 - t2 < 7 * 24 * 60 * 60 * 1000) {
        this.discountData = {
          activity_type: 'will_out',
          ...info,
        }
      } else {
        this.discountData = info
      }
    }
    if (!plan_publish_time && !plan_unpublish_time) {
      this.discountData = {
        ...info,
      }
    }
  }

  async changeLevel(level: any = {}) {
    if (level.noLevel) {
      this.skuStatus = '缺货'
      delete level.noLevel
    } else {
      this.skuStatus = ''
    }
    this.curLevel = level
    if (!level.id) {
      this.discountData = {}
    }
    console.log('changed', level)
    this.setActivity()
    // await this.getShipping()
  }
  giftEnable(activity) {
    let activityNames = Array.from(
      new Set(
        Object.values(this.skuActivity)
          .map(i => i.activity_type)
          .concat(this.curLevel.channel_activity ? ['channel'] : [])
      )
    )
    if (!activity.isOverlay && activityNames.length) {
      return false
    }
    let activityNameSet = new Set(activityNames)
    for (let actname of activity.overlay || []) {
      activityNameSet.delete(actname)
    }
    // 分销单独显示
    if (
      activityNameSet.size === 1 &&
      activityNameSet.has('scholarship_distribution')
    ) {
      return true
    }
    if (activityNameSet.size) {
      return false
    }
    return true
  }
  async showLevel(buttonName, type) {
    console.log('当前活动信息', this.discountData)
    let activityNames = Array.from(
      new Set(
        Object.values(this.skuActivity)
          .map(i => i.activity_type)
          .concat(this.curLevel.channel_activity ? ['channel'] : [])
      )
    )

    let _payload = {
      visible: true,
      type: this.spu.scope,
      spuData: this.spu,
      skuData: this.skus,
      attrData: this.attrs,
      attrMap: this.attrsMap,
      attrName: this.name,
      curLevel: this.curLevel,
      changeLevel: this.changeLevel,
      buttonName,
      skuActivity: this.skuActivity,
      goldShow: this.$route.query.invitation,
      goldData: this.invitationData,
      goldDiscount: this.invitationData.discounted_value,
      activityNames,
      goodsStatus: this.goodsStatus,
      uploadEvent,
      showDistributionShare: this.showDistributionShare,
    }

    console.log('-----', type)
    if (type === 'buy') {
      if (this.skus.length <= 1) {
        // 埋点 点击立即购买
        await addStatistics({
          event: 'Click_GoodDetails_Buy_H5',
          p1: this.$route.query.nativeFrom, // 页面来源
          p2: this.point,
          p3: this.goodsStatus,
        })
        this.toConfirm(buttonName)
        return
      }

      if (activityNames.includes('group') && buttonName !== 'group') {
        activityNames = activityNames.filter(item => item !== 'group')
      }

      // 埋点 选择规格界面曝光
      addStatistics({
        event: 'ExposureTimes_Choose_Specification_H5',
        p1: this.point,
        p2: this.goodsStatus,
      })
      let _curLevel =
        this.spu.scope === 'goods'
          ? await showDiv(
              LevelAttrShow,
              Object.assign(_payload, {
                collocationList: this.$route.query.invitation
                  ? []
                  : this.collocationList,
              })
            )
          : await showDiv(levelShow, _payload)
      if (_curLevel && _curLevel.type === 'toCollocation') {
        this.toCollocationConfirm(_curLevel.cid)
      } else if (_curLevel) {
        this.curLevel = _curLevel
        this.giftList = _curLevel.gifts
        // 埋点 点击立即购买
        await addStatistics({
          event: 'Click_GoodDetails_Buy_H5',
          p1: this.$route.query.nativeFrom, // 页面来源
          p2: this.point,
          p3: this.goodsStatus,
        })
        // 智能埋点 点击立即购买
        this.toConfirm(buttonName)
      }
    }

    if (type === 'cart') {
      let _curLevel =
        this.spu.scope === 'goods'
          ? await showDiv(LevelAttrShow, { ..._payload, notFooterType: 'cart' })
          : await showDiv(levelShow, _payload)
      if (_curLevel) {
        this.curLevel = _curLevel
        this.giftList = _curLevel.gifts
        // 多规格加入购物车
        const {
          data: { data: res },
        } = await goodsApi.addToCart({
          sku_id: _curLevel.id,
          num: _curLevel._num || 1,
        })
        this.$refs.footView['cartNum'] = res.total_cart
        this.$Toast('已成功添加至购物车')
      }
    }
  }

  async toConfirm(type = '') {
    if (!this.curLevel || (this.curLevel && !this.curLevel.id)) {
      return this.$Toast('请选择组合')
    }
    if (this.isApp) {
      await env.init()
      const isLogin = await env.getIsLogin()
      if (!isLogin) {
        this.ios10Shadow = true
        return await env.login()
      }
    }
    let isGroup = type === 'group' ? 'true' : ''

    let {
      scholarship_distribution_id,
      scholarship_distributor_id,
    } = this.$route.query

    if (this.isInvitation) {
      let query = {
        spuId: this.queryParams.spuId,
        skuId: this.curLevel.id,
        channel_id: this.queryParams.channel_id,
        channel_activity: this.curLevel.channel_activity,
        gift_activity:
          this.curLevel.giftsActivity && this.curLevel.giftsActivity.id,
        type: this.spu.scope,
        isGroup,
        ignoreDiscount: this.$route.query.ignoreDiscount,
        application: (this.discountData.tag === '限时报名' ? true : false) + '',
        startTime: this.discountData.start_time,
        receiver_id: this.addressChecked && this.addressChecked.id,
        invitation: this.queryParams.invitation,
        invitationId: this.$route.query.invitationId,
      }
      if (!this.curLevel.need_receiver) {
        return await showDiv(GoldVirtually, {
          goldData: this.invitationData,
          query,
        })
      }
      this.$router.push({
        path: `/orderConfirm`,
        query,
      })
    } else if (this.isApp) {
      let path = 'pages/new-goods-confirm/index.js'
      let confirmInfo = {
        courseTitle: this.spu.title,
        virtualType:
          (this.curLevel.virtual && this.curLevel.virtual.virtual_type) || '',
        from: 'product-details-page',
        type: this.spu.scope,
        activityType: this.discountData.activity_type,
        isGroup: !!isGroup,
        pageFrom: '商品详情页',
        skuId: this.curLevel.id,
        isAppStore: this.$route.query.isAppStore === 'true',
        channelActivity: this.curLevel.channel_activity,
        giftActivity:
          this.curLevel.giftsActivity && this.curLevel.giftsActivity.id,
        goodsNum: 1,
        is_auto_success: isGroup ? !this.discountData.auto_success : false,
        scholarship_distribution_id: scholarship_distribution_id || '',
        scholarship_distributor_id: scholarship_distributor_id || '',
        userPrice: this.curLevel.salePrice,
      }
      let groupParamsInfo = {}
      let presellParamsInfo = {}
      if (this.discountData.activity_type === 'presell') {
        presellParamsInfo = {
          presellActivityId: this.discountData.id,
          presellPayType: 'depoist',
        }
      } else if (this.discountData.activity_type === 'group') {
        groupParamsInfo = {
          groupLeaderId: 0,
          groupType: 'create',
          groupActivityId: this.discountData.id,
        }
      }
      let info = {
        path: path,
        confirmInfo: confirmInfo,
        groupParamsInfo: groupParamsInfo,
        presellParamsInfo: presellParamsInfo,
      }
      await env.openGoodsConfirm(info)
    } else {
      this.$router.push({
        path: `/orderConfirm`,
        query: {
          spuId: this.queryParams.spuId,
          skuId: this.curLevel.id,
          channel_id: this.queryParams.channel_id,
          channel_activity: this.curLevel.channel_activity,
          gift_activity:
            this.curLevel.giftsActivity && this.curLevel.giftsActivity.id,
          type: this.spu.scope,
          isGroup,
          ignoreDiscount: this.$route.query.ignoreDiscount,
          application:
            (this.discountData.tag === '限时报名' ? true : false) + '',
          startTime: this.discountData.start_time,
          receiver_id: this.addressChecked && this.addressChecked.id,
          invitation: this.queryParams.invitation,
          invitationId: this.$route.query.invitationId,
          scholarship_distribution_id: scholarship_distribution_id || '',
          scholarship_distributor_id: scholarship_distributor_id || '',
          user_price: this.curLevel.salePrice,
        },
      })
    }
  }
  async toDetail(val) {
    let acticityInfo = this.collocationList[0] || {}
    // 埋点-商详页点击搭配购区域
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_Collocation',
      '',
      {
        GoodsName: this.spu.title,
        SkuID: this.skus.reduce((t, c, i) => {
          t += i === 0 ? c.id : `_${c.id}`
          return t
        }, ''),
        ActivityName: acticityInfo.title,
        ActivityID: acticityInfo.id,
      },
      [
        ['p1', 'GoodsName'],
        ['p2', 'SkuID'],
        ['p3', 'ActivityName'],
        ['p4', 'ActivityID'],
      ]
    )
    const id = val
    this.$router.push({
      path: `/goodsSalesDetail`,
      query: {
        spuId: this.queryParams.spuId,
        cid: id,
        skuId: this.curLevel.id,
        channel_id: this.queryParams.channel_id,
        channel_activity: this.curLevel.channel_activity,
        gift_activity:
          this.curLevel.giftsActivity && this.curLevel.giftsActivity.id,
        type: this.spu.scope,
        ignoreDiscount: this.$route.query.ignoreDiscount,
        application: (this.discountData.tag === '限时报名' ? true : false) + '',
        startTime: this.discountData.start_time,
        receiver_id: this.addressChecked && this.addressChecked.id,
        invitation: this.queryParams.invitation,
        f_r_o_m: 'goodsView',
      },
    })
  }
  async toCollocationList() {
    let acticityInfo = this.collocationList[0] || {}
    // 埋点-商详页点击更多搭配
    await uploadEvent.sendRecord(
      'Click_GoodsDetail_MoreCollocation',
      '',
      {
        GoodsName: this.spu.title,
        SkuID: this.skus.reduce((t, c, i) => {
          t += i === 0 ? c.id : `_${c.id}`
          return t
        }, ''),
        ActivityName: acticityInfo.title,
        ActivityID: acticityInfo.id,
      },
      [
        ['p1', 'GoodsName'],
        ['p2', 'SkuID'],
        ['p3', 'ActivityName'],
        ['p4', 'ActivityID'],
      ]
    )
    this.$router.push({
      path: '/collocationList',
      query: {
        skuId: this.skus.map(i => i.id),
        channel_id: this.queryParams.channel_id,
        curSku: this.curLevel.id,
        f_r_o_m: 'goodsView',
      },
    })
  }
  showIos10Shadow() {
    this.ios10Shadow = true
  }
  ios10ShadowClick() {
    window.location.reload()
  }

  // 搭配售订单确认
  async toCollocationConfirm(cid) {
    if (!cid) return
    await env.init()
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      // 用户未注册
      return await env.login()
    }
    let curInfo = this.collocationList.find(el => el.id == cid)
    let skuIds = curInfo && curInfo.goodsList.map(el => el.sku_id)
    let { data } = await this.$axios.get(
      `/api/goods/shop/search/collocation/isActivityWorking`, // 搭配购是否还可购买
      {
        params: {
          cid: cid,
          sku_ids: skuIds,
        },
      }
    )
    if (data.valid) {
      if (env.type === 'ivydad') {
        // 是否在app内
        let path = 'pages/new-goods-confirm-collocation/index.js'
        let confirmInfo = {
          courseTitle: curInfo.title,
          from: 'product-details-page',
          type: this.spu.scope || 'goods',
          pageFrom: '搭配售详情页',
          skus: curInfo.goodsList.map(el => {
            return {
              goodsNum: el.num,
              skuId: el.sku_id,
            }
          }),
          cid,
          channelActivity: this.curLevel.channel_activity,
          giftActivity:
            this.curLevel.giftsActivity && this.curLevel.giftsActivity.id,
        }
        let info = {
          path: path,
          confirmInfo: confirmInfo,
        }
        await env.openCollocationConfirm(info)
      } else {
        this.$router.push({
          path: `/orderConfirm`,
          query: {
            skuId: skuIds,
            channel_id: this.$route.query.channel_id,
            goodType: 'true',
            cid,
          },
        })
      }
    } else {
      this.$Toast(data.message)
    }
  }

  async addDistPoint(
    type,
    distributionActivityId,
    scholarshipDistributorId = ''
  ) {
    let loginfo = (await env.getInfo()) || {}
    let logined = loginfo.logined || {}
    let user = logined.user || {}

    this.$axios.post(
      '/api/goods/shop/market/scholarshipDistribution/recordDistributionStatistics',
      {
        scholarship_distribution_id: distributionActivityId,
        scholarship_distributor_id: scholarshipDistributorId || user.id,
        sku_id: this.curLevel.id,
        type: type,
        sku_type: 1,
        customer_wx_unionid: logined.unionid,
        customer_wx_avatar: logined.headimgurl,
        customer_wx_nickname: logined.nickname,
      },
      {
        disableAlert: true,
      }
    )
  }
  // 展示分销提示框
  async showDistributionShare() {
    // 记录日志
    this.addDistPoint('share', this.curLevel.distributionActivityId)

    let { data } = await this.$axios.post(
      '/api/goods/shop/market/scholarshipDistribution/shareDistribution',
      {
        scholarship_distribution_id: this.curLevel.distributionActivityId,
        sku_id: this.curLevel.id,
        distributorMemId: this.$route.query.distributorMemId || '',
      }
    )

    this.share_img_url = data.poster_url
    this.showShare = true
  }
  async shareSuccess() {
    let localId = window.localStorage.getItem('__ActivityId')
    let localTime = window.localStorage.getItem('__ActivityIdTime')

    let dayActivity =
      '' + new Date().getDay() + this.curLevel.distributionActivityId

    console.log(
      '----',
      localId,
      localTime,
      this.curLevel.distributionActivityId,
      dayActivity
    )
    // 该活动没有不在梯形且当天该活动没有弹过
    if (
      +localId != this.curLevel.distributionActivityId &&
      localTime != dayActivity
    ) {
      window.localStorage.setItem(
        '__ActivityIdTime',
        '' + new Date().getDay() + this.curLevel.distributionActivityId
      )
      let { data } = await this.$axios.get(
        '/api/goods/shop/market/scholarshipDistribution/judgePopSubWindow'
      )

      if (data) {
        this.showFollow = true
      }
    }
  }
}
